import img from "assets/images/content-block-thumbnails/kanban.png";

import {
  blockType,
  blockTypeDbName,
  blockTypeToName,
  blockNameToType,
} from "./constants";

import { KanbanBlockSchema } from "./schema";
import { strings } from "./strings";

import { allowed } from "./lib/allowed";
import { create } from "./lib/create";
import { map } from "./lib/map";

import type { Kanban as KanbanType } from "./types";
import { copy } from "./copy";

export const Kanban: KanbanType = {
  strings,

  blockType,
  blockTypeDbName,
  blockTypeToName,
  blockNameToType,

  thumbnailImage: img,
  thumbnail: {
    name: strings.NAME,
    image: img,
    type: blockType,
  },

  schema: KanbanBlockSchema,

  allowed,
  create,
  map,
  copy,
} as const;
